export const HASH_TAG_REQUEST = 'HASH_TAG_REQUEST';
export const HASH_TAG_SUCCESS = 'HASH_TAG_SUCCESS';
export const HASH_TAG_FAIL = 'HASH_TAG_FAIL';